<template xmlns:color="http://www.w3.org/1999/xhtml">
  <div class="row">
    <!--  申请用户信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="申请用户信息">
        <div class="row">
          <div class="flex md6 sm6 xs12">
            <va-input
              label="学员uid"
              v-model="insertData.user.uid"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="学员姓名"
              v-model="insertData.user.nickname"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="联系邮箱"
              v-model="insertData.email"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="申请提交时间"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.status"
              label="处理状态"
              :options="statusOptions"
              no-clear
            />
          </div>
        </div>
        <div class="row justify--center">
          <div class="flex md2">
            <a :href="insertData.resumeUrl" target="_Blank">
              <va-button class="ma-0" color="primary" slot="trigger">
                简历<!--{{insertData.fileName}}-->
              </va-button>
            </a>
          </div>
          <div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="processAppliedJob" :disabled="!submitButtonStatus">
              保存
            </va-button>
          </div>
          <div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="$router.push({ name: 'listAppliedJob' })">
              返回
            </va-button>
          </div>
          <!--<div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="$router.push({ path: `/admin/users/updateUser/${insertData.user.uid}` })">
              查看用户信息
            </va-button>
          </div>-->

        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card title="岗位">
        <div class="row">
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='referral.id'
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="organization.name"
              label="公司名称"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="referral.position"
              label="岗位"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="referral.location"
              label="工作地点"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.referral.organizationJobLink"
              label="岗位链接"
              disabled
            />
          </div>
<!--          <div class="flex md12 sm6 xs12">-->
<!--            <va-input-->
<!--              type="textarea"-->
<!--              v-model="referral.responsibility"-->
<!--              label="工作职责"-->
<!--              disabled-->
<!--            />-->
<!--          </div>-->
<!--          <div class="flex md12 sm6 xs12">-->
<!--            <va-input-->
<!--              type="textarea"-->
<!--              v-model="referral.jobRequirement"-->
<!--              label="职位要求"-->
<!--              disabled-->
<!--            />-->
<!--          </div>-->
        </div>
        <!--        <div class="row justify&#45;&#45;center">
          <div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="$router.push({ path: `/admin/referrals/updateReferral/${insertData.referral.id}` })">
              查看完整岗位信息
            </va-button>
          </div>
          <div class="flex md2">
            <va-button class="ma-0" color="gray" slot="trigger" @click="$router.push({ name: 'listAppliedJob' })">
              返回
            </va-button>
          </div>
        </div>-->
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '../../../utils/common'
import appliedJobApi from '../../../api/appliedJob'
import { USER_APPLICATION_STATUS_TYPES } from '../../../utils/constants'
import referralApi from '../../../api/referral'

export default {
  data () {
    return {
      insertData: {
        id: null,
        resumeUrl: '',
        fileName: '',
        email: '',
        createTime: '',
        referral: {},
        user: {},
        status: '',
      },
      referral: {
        organizationJobLink: '',
      },
      organization: {},
      message: ['Required field'],
      title: '',
      statusOptions: USER_APPLICATION_STATUS_TYPES.map(x => { return x.TEXT }),
      submitButtonStatus: true,
    }
  },
  created () {
    this.getAppliedJob()
  },
  computed: {

  },
  methods: {
    getAppliedJob () {
      const params = this.$route.params
      if (params.id != null) {
        // 通过id获取详情
        appliedJobApi.getAppliedJob(params.id).then(response => {
          copyObject(response.appliedJob, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          this.computeCodeToStatus(response.appliedJob.status)
          this.getReferral(response.appliedJob.referral.id)
          //this.referral.organizationJobLink = response.appliedJob.referral.organizationJobLink
          console.log(response.appliedJob.referral.organizationJobLink)
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    getReferral (id) {
      referralApi.getReferral(id).then(response => {
        this.referral = response.referral
        this.organization = response.organization
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    processAppliedJob () {
      this.changeButtonStatus(false)
      const data = {
        id: this.insertData.id,
        status: this.computeStatusToCode(this.insertData.status),
      }
      appliedJobApi.processAppliedJob(data.id, data).then(response => {
        if (response.success === true) {
          this.changeButtonStatus(true)
          this.showToast('更新处理状态成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.getAppliedJob()
        }
      }).catch(error => {
        this.changeButtonStatus(true)
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computeCodeToStatus (code) {
      USER_APPLICATION_STATUS_TYPES.map(x => {
        if (x.CODE === code) {
          this.insertData.status = x.TEXT
        }
      })
    },
    computeStatusToCode (status) {
      let code = -1
      USER_APPLICATION_STATUS_TYPES.map(x => {
        if (x.TEXT === status) {
          code = x.CODE
        }
      })
      return code
    },
    resetStatus () {
    },
    clickCancel () {
    },
    checkField () {
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
